import React from "react";
import Layout from 'layout/index.js'

import { Link } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';

import { authenticationService } from 'auth/authenticationService'
import { FilterStorage } from 'adds/FilterStorage'



// import DateAdapter from '@mui/lab/AdapterDateFns';

import Stack from '@mui/material/Stack';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

import {
  Paper,
  Box,
  Button,
  Typography,
  Alert,
  TextField,
  TableSortLabel, TablePagination, TableContainer, Table, TableRow, TableHead, TableBody, TableCell,
  FormControl, InputLabel, Select, MenuItem,
  CircularProgress, Grid,
  Collapse,
  Radio, RadioGroup, FormLabel, FormControlLabel,
  // FormHelperText,

} from '@mui/material';

const headCells = [
  { id: "collapse_col", numeric: false, disablePadding: false, label: "", sorting: false },
  { id: "fecha_actualizacion", numeric: false, disablePadding: false, label: "Fecha última actualización", sorting: false },
  { id: "informacion", numeric: false, disablePadding: false, label: "Información vehículo", sorting: false },
  { id: "estado", numeric: false, disablePadding: false, label: "Estado del permiso", sorting: false },
  { id: "estadisticas", numeric: false, disablePadding: false, label: "Estadísticas", sorting: false },
  { id: "username", numeric: false, disablePadding: false, label: "Agente", sorting: false },
  { id: "detalles", numeric: false, disablePadding: false, label: "Ver", sorting: false },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          !headCell.sorting ? <TableCell key={headCell.id}>{headCell.label}</TableCell> : (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className='hideSort'>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
}

function encodeQueryData(data) {
  const ret = [];
  for (let d in data)
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
}

function Row(props) {
  const { object } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>

        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <Typography variant='caption'>
            {(new Date(object.fecha_actualizacion)).toLocaleString('es-CL').split(',')[0]}
            <br />
            {(new Date(object.fecha_actualizacion)).toLocaleString('es-CL').split(',')[1]}
          </Typography>
        </TableCell>
        <TableCell>

          <Box>
            <Box>
              <Typography variant='caption'>Tipo permiso:</Typography>
            </Box>
            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>{object.tipo ? object.tipo : ''}</Typography>
          </Box>
          <Box>
            <Box>
              <Typography variant='caption'>Patente:</Typography>
            </Box>
            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>{object.vehiculo ? object.vehiculo.patente : ''}</Typography>
          </Box>
          <Box>
            <Box>
              <Typography variant='caption'>Categoría:</Typography>
            </Box>
            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
              {object.vehiculo?.categoria_tipo === 1 ? "Vehiculo liviano" :
                object.vehiculo?.categoria_tipo === 3 ? "Vehiculo Pesado" :
                  object.vehiculo?.categoria_tipo === 2 ? "Locomoción colectiva" :
                    "Hay un error con el vehículo. Por favor contáctanos en el chat para corregirlo"
              }
            </Typography>
          </Box>
          <Box>
            <Typography variant='caption'>Contribuyente:</Typography>
            <Box>
              <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
                {object.contribuyente ? object.contribuyente : ''}
              </Typography>
            </Box>
          </Box>
        </TableCell>

        <TableCell>
          <Alert severity={object.estado_consolidado === 0 ? 'warning' :
            object.estado_consolidado === 1 ? 'success' :
              object.estado_consolidado === 2 ? 'error' :
                object.estado_consolidado === 3 ? 'info' :
                  object.estado_consolidado === 4 ? 'success' :
                    object.estado_consolidado === 5 ? 'warning' :
                      object.estado_consolidado === 6 ? 'warning' :
                      'info'}
            style={{ minHeigth: '100px' }}
            variant={[4, 5, 6].includes(object.estado_consolidado) ? 'filled' : 'standard'}>
            <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
              {object.estado}
            </Typography>
          </Alert>

          <Box>
            <Box>
              <Typography variant='caption'>
                <Box sx={{ display: 'inline', fontWeight: 'bold' }}>{object.numero_completos}</Box> sec. listas
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption'>
                <Box sx={{ display: 'inline', fontWeight: 'bold' }}>{object.numero_rechazados} </Box>sec. rechazadas
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption'>
                <Box sx={{ display: 'inline', fontWeight: 'bold' }}>{object.numero_incompletos} </Box>sec. incompletas
              </Typography>
            </Box>
          </Box>

        </TableCell>

        <TableCell align="center">
          <Typography variant='caption'>


          </Typography>

          <Box>
            <Typography variant='caption'>Notificaciones</Typography>
            <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
              : {object.numero_notificaciones}
            </Typography>
          </Box>
          {object.ultima_notificacion &&
            <Box>
              <Typography variant='caption'>Última notificación:</Typography>
              <Box>
                <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
                  {(new Date(object.ultima_notificacion.created_at)).toLocaleString('es-CL')}
                  <br />
                  ({object.ultima_notificacion.who ? object.ultima_notificacion.who.split('@')[0] : 'Sin agente'})
                </Typography>
              </Box>
            </Box>
          }
        </TableCell>

        <TableCell>
          <Typography variant='caption'>
            {object.agente?.split('@')[0]}
          </Typography>
        </TableCell>
        <TableCell>
          <Button component={Link}
            to={'/permisos/administracion_vehiculo/' + object.vehiculo.vehiculo_uuid} color='primary'
            startIcon={<FormatListBulletedIcon />}>
            Ver detalles
          </Button>
          <Box>
            <Typography variant='caption' sx={{ fontWeight: 'bold' }}>Año proceso:</Typography>
            <Typography variant='caption'>{object.agno_proceso}</Typography>
          </Box>

        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box pl={5} sx={{ margin: 1 }}>
              <Box>
                <Typography variant='h6' color='primary'>Estado secciones</Typography>
                <Grid container spacing={1}>
                  <Grid item xs={2}>
                    <Alert severity={object.estado_contribuyente === 0 ? 'warning' :
                      object.estado_contribuyente === 1 ? 'success' :
                        object.estado_contribuyente === 2 ? 'error' :
                          object.estado_contribuyente === 3 ? 'info' :
                            'info'}
                      icon={false}>
                      <Typography variant='caption'>
                        Contribuyente
                      </Typography>
                    </Alert>
                  </Grid>
                  <Grid item xs={2}>
                    <Alert severity={object.estado_identificacion === 0 ? 'warning' :
                      object.estado_identificacion === 1 ? 'success' :
                        object.estado_identificacion === 2 ? 'error' :
                          object.estado_identificacion === 3 ? 'info' :
                            'info'}
                      icon={false}>
                      <Typography variant='caption'>
                        Identificación Vehículo
                      </Typography>
                    </Alert>
                  </Grid>

                  <Grid item xs={2}>
                    <Alert severity={object.estado_sii === 0 ? 'warning' :
                      object.estado_sii === 1 ? 'success' :
                        object.estado_sii === 2 ? 'error' :
                          object.estado_sii === 3 ? 'info' :
                            'info'}
                      icon={false}>
                      <Typography variant='caption'>
                        Tasación SII
                      </Typography>
                    </Alert>
                  </Grid>

                  <Grid item xs={2}>
                    <Alert severity={object.estado_prt === 0 ? 'warning' :
                      object.estado_prt === 1 ? 'success' :
                        object.estado_prt === 2 ? 'error' :
                          object.estado_prt === 3 ? 'info' :
                            'info'}
                      icon={false}>
                      <Typography variant='caption'>
                        Revisión Técnica
                      </Typography>
                    </Alert>
                  </Grid>

                  <Grid item xs={2}>
                    <Alert severity={object.estado_soap === 0 ? 'warning' :
                      object.estado_soap === 1 ? 'success' :
                        object.estado_soap === 2 ? 'error' :
                          object.estado_soap === 3 ? 'info' :
                            'info'}
                      icon={false}>
                      <Typography variant='caption'>
                        Seguro obligatorio
                      </Typography>
                    </Alert>
                  </Grid>


                  <Grid item xs={2}>
                    <Alert severity={object.estado_multas === 0 ? 'warning' :
                      object.estado_multas === 1 ? 'success' :
                        object.estado_multas === 2 ? 'error' :
                          object.estado_multas === 3 ? 'info' :
                            'info'}
                      icon={false}>
                      <Typography variant='caption'>
                        Multas
                      </Typography>
                    </Alert>
                  </Grid>

                </Grid>
              </Box>

              <Box p={1} sx={{ backgroundColor: "#EEEEEE" }}>
                <Typography variant='overline'>
                  Comentario interno
                </Typography>
                <pre>
                  <Typography variant='body2' color='primary'>
                    {object.comentario_interno && object.comentario_interno !== '' ? object.comentario_interno : 'Sin cometario'}
                  </Typography>
                </pre>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


class BandejaPermisos extends React.Component {
  constructor(props) {
    super(props);


    var end = new Date();
    var start = new Date(2022, 1, 2, 0, 0, 0);

    this.state = {

      objects: [],

      html: {
        list: true,
        loading: false,
        descargando_excel: false
      },
      filters: {
        estado_consolidado: '',
        estado_contribuyente: '0',
        estado_identificacion: '0',
        estado_sii: '0',
        estado_prt: '0',
        estado_soap: '0',
        estado_multas: '0',
        tipo: 'todos',
        datos_contribuyente: 'todos',
        start_date: start,
        end_date: end
      },
      pagination: {
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
        order_by: 'fecha_actualizacion',
        order: 'desc',
      },
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleFiltrar = this.handleFiltrar.bind(this);
    this.handleDescargarExcel = this.handleDescargarExcel.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePageManual = this.handleChangePageManual.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);

    this.handleDateFilter = this.handleDateFilter.bind(this);
  }



  handleChangePage(event, page) {
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        page: page,
      }
    }), () => {
      FilterStorage.setFilter(this.props.tipo, 'pagination', this.state.pagination);
      this.handleLoad()
    });

  }
  handleChangePageManual(event) {
    const { name, value } = event.target;

    console.log(value)
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        page: value,
      }
    }), () => {
      FilterStorage.setFilter(this.props.tipo, 'pagination', this.state.pagination);
      this.handleLoad()
    });

  }
  handleChangeRowsPerPage(event) {
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        rows_per_page: event.target.value,
      }
    }), () => {
      FilterStorage.setFilter(this.props.tipo, 'pagination', this.state.pagination);
      this.handleLoad()
    });
  }

  handleSort(event, property) {
    const isAsc = this.state.pagination.order_by === property && this.state.pagination.order === "asc";
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        order: isAsc ? "desc" : "asc",
        order_by: property,
      }
    }), () => {
      FilterStorage.setFilter(this.props.tipo, 'pagination', this.state.pagination);
      this.handleLoad()
    });
  }

  handleFiltrar() {
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        page: 0,
        order_by: this.state.pagination.order_by,
        order: this.state.pagination.order,
        rows_per_page: this.state.pagination.rows_per_page,
      }

    }), () => {

      FilterStorage.setFilter(this.props.tipo, 'pagination', this.state.pagination);
      this.handleLoad()
    });
  }

  handleLoad(limpiar = false) {

    this.setState(prevState => ({
      html: {
        ...prevState.html,
        loading: true
      },
    }));

    let params = {};
    let filters = FilterStorage.getFilter(this.props.tipo, 'filters');
    let pagination = FilterStorage.getFilter(this.props.tipo, 'pagination');
    // console.log('filters: ',filters)
    // console.log('pagination: ',pagination)

    if (filters && pagination && !limpiar) {
      params = {
        ...filters,
        ...pagination,
        agno_proceso: 'last'
      }
    }
    else {
      filters = {}

      pagination = {
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
        order_by: 'fecha_actualizacion',
        order: 'desc',
      };
      // console.log('entra al reset')
      FilterStorage.setFilter(this.props.tipo, 'pagination', pagination);

      // filters['agno_proceso'] = 2022
      filters['patente'] = '';
      filters['contribuyente_email'] = '';
      filters['estado_consolidado'] = 'todos'

      filters['estado_contribuyente'] = '-1'
      filters['estado_identificacion'] = '-1'
      filters['estado_prt'] = '-1'
      filters['estado_soap'] = '-1'
      filters['estado_multas'] = '-1'
      filters['estado_sii'] = '-1'
      filters['tipo'] = 'todos'
      filters['datos_contribuyente'] = 'todos'

      filters['start_date'] = (new Date(2023, 1, 2, 0, 0, 0)).toISOString();
      filters['end_date'] = (new Date()).toISOString();;

      if (this.props.tipo && this.props.tipo === 'pendiente_validacion') {
        filters['estado_consolidado'] = 0;
      }
      else if (this.props.tipo && this.props.tipo === 'secciones_incompletas') {
        filters['estado_consolidado'] = 3;
      }
      else if (this.props.tipo && this.props.tipo === 'secciones_rechazadas') {
        filters['estado_consolidado'] = 2;
      }
      else if (this.props.tipo && this.props.tipo === 'pagados') {
        filters['estado_consolidado'] = 4;
      }
      else if (this.props.tipo && this.props.tipo === 'mios') {
        filters['username'] = authenticationService.currentUser.username
      }


      FilterStorage.setFilter(this.props.tipo, 'filters', filters);

      params = {
        ...filters,
        ...pagination,
        agno_proceso: 'last'
      }


    }


    var query = encodeQueryData(params)

    authenticationService.fetchApi({
      url: '/permisos/permiso/?' + query,
      method: 'GET',
    })
      .then(result => {

        this.setState(prevState => ({
          pagination: result.pagination,
          filters: filters,
          html: {
            ...prevState.html,
            loading: false
          },
          objects: result.data
        }), () => {
          FilterStorage.setFilter(this.props.tipo, 'pagination', this.state.pagination);
        });
      })
      .catch(err => {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            loading: false
          },
        }));
      });

  }

  // Descarga en Excel la búsqueda actual (mismos filtros y orden que la bandeja, sin paginar)
  handleDescargarExcel() {
    let filters = FilterStorage.getFilter(this.props.tipo, 'filters') || {};
    let params = {
      ...filters,
      order_by: this.state.pagination.order_by,
      order: this.state.pagination.order,
      agno_proceso: 'last',
      xlsx: true
    };

    this.setState(prevState => ({
      html: {
        ...prevState.html,
        descargando_excel: true
      },
    }));

    authenticationService.fetchApi({
      url: '/permisos/permiso/?' + encodeQueryData(params),
      method: 'GET',
      ContentType: 'file'
    })
      .then(result => result.blob())
      .then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        let ahora = new Date();
        a.href = url;
        a.download = 'busqueda_permisos_' + ahora.toISOString().slice(0, 10) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => { })
      .finally(() => {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            descargando_excel: false
          },
        }));
      });
  }

  componentDidMount() {
    let filters = FilterStorage.getFilter(this.props.tipo, 'filters');
    let pagination = FilterStorage.getFilter(this.props.tipo, 'pagination');
    if (filters && pagination) {
      this.setState(prevState => ({
        filters: filters,
        pagination: pagination
      }));
    }
    this.handleLoad();
  }
  handleFilterChange(event) {
    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value, checked } = event.target;
    if (name === 'order') {
      currentState[name] = checked;
    }
    else {
      currentState[name] = value;
    }

    // console.log('before: ', this.state.filters)
    this.setState({ filters: currentState }, () => {
      // console.log('after: ', this.state.filters)
      FilterStorage.setFilter(this.props.tipo, 'filters', this.state.filters);
    });

  }
  handlePaginationChange(event) {
    const { pagination } = { ...this.state };
    const currentState = pagination;
    const { name, value } = event.target;

    currentState[name] = value;

    // console.log('before: ', this.state.filters)
    this.setState({ pagination: currentState }, () => {
      console.log('after: ', this.state.pagination)
      FilterStorage.setFilter(this.props.tipo, 'pagination', this.state.pagination);
    });

  }
  handleDateFilter(name, date = null) {
    const { filters } = { ...this.state };
    const currentState = filters

    currentState[name] = date;
    this.setState({ filters: currentState }, () => {
      FilterStorage.setFilter(this.props.tipo, 'filters', this.state.filters);
    });
  }
  render() {
    return (

      <Paper>
        <Box m={1}>
          <Box p={1}>
            {this.props.tipo === 'pendiente_validacion' &&
              <Typography variant='h5' color='primary'>Permisos pendientes a validacion</Typography>
            }

            {this.props.tipo === 'secciones_incompletas' &&
              <Typography variant='h5' color='primary'>Permisos con secciones incompletas</Typography>
            }
            {this.props.tipo === 'secciones_rechazadas' &&
              <Typography variant='h5' color='primary'>Permisos con secciones rechazadas</Typography>
            }
            {this.props.tipo === 'mios' &&
              <Typography variant='h5' color='primary'>Mis permisos</Typography>
            }
            {!['mios', 'pendiente_validacion', 'secciones_incompletas', 'secciones_rechazadas'].includes(this.props.tipo) &&
              <Typography variant='h5' color='primary'>Todos los permisos del periodo vigente</Typography>
            }
          </Box>
          <Box p={1}>
            <TextField name='patente'
              id='patente'
              label='Buscar por patente'
              placeholder='Buscar por patente'
              fullWidth
              maxLength='100'
              value={this.state.filters.patente ? this.state.filters.patente : ''}
              onChange={this.handleFilterChange}
              variant="standard"
            />
          </Box>

          <Box p={1}>
            <TextField name='contribuyente_email'
              id='contribuyente_email'
              label='Buscar por mail del contribuyente'
              placeholder='Buscar por mail del contribuyente'
              fullWidth
              maxLength='200'
              value={this.state.filters.contribuyente_email ? this.state.filters.contribuyente_email : ''}
              onChange={this.handleFilterChange}
              variant="standard"
            />
          </Box>


          <Box>
            <Box p={1}>
              <FormControl fullWidth={true}
                variant="standard"
              >
                <InputLabel id="tipo_lb">Tipo</InputLabel>
                <Select labelId="tipo_lb"
                  id="tipo"
                  name="tipo"
                  value={this.state.filters.tipo ? this.state.filters.tipo : ''}
                  onChange={this.handleFilterChange}
                >
                  <MenuItem key='todos' value='todos'>Todos</MenuItem>
                  <MenuItem key='Renovación' value='Renovación'>Renovación</MenuItem>
                  <MenuItem key='Traslado' value='Traslado'>Traslado</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box p={1}>
              <FormControl fullWidth={true}
                variant="standard"
              >
                <InputLabel id="datos_contribuyente_lb">Datos del contribuyente</InputLabel>
                <Select labelId="datos_contribuyente_lb"
                  id="datos_contribuyente"
                  name="datos_contribuyente"
                  value={this.state.filters.datos_contribuyente ? this.state.filters.datos_contribuyente : 'todos'}
                  onChange={this.handleFilterChange}
                >
                  <MenuItem key='todos' value='todos'>Todos</MenuItem>
                  <MenuItem key='sin_datos' value='sin_datos'>Sin datos del contribuyente</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          {!['pendiente_validacion', 'secciones_incompletas', 'secciones_rechazadas', 'pagados'].includes(this.props.tipo) &&
            <Box>

              <Box p={1}>
                <FormControl fullWidth={true}
                  variant="standard"
                >
                  <InputLabel id="tipo_label">Estado permiso</InputLabel>
                  <Select labelId="tipo_label"
                    id="estado_consolidado"
                    name="estado_consolidado"
                    value={this.state.filters.estado_consolidado ? this.state.filters.estado_consolidado : ''}
                    onChange={this.handleFilterChange}
                  >
                    <MenuItem key='todos' value='todos'>Todos</MenuItem>
                    <MenuItem key='0' value='0'>Secciones por validar</MenuItem>
                    <MenuItem key='1' value='1'>Listo para Pago</MenuItem>
                    <MenuItem key='2' value='2'>Secciones rechazadas</MenuItem>
                    <MenuItem key='3' value='3'>Secciones incompletas</MenuItem>
                    <MenuItem key='4' value='4'>Pagado</MenuItem>
                    <MenuItem key='5' value='5'>Descartado</MenuItem>
                    <MenuItem key='6' value='6'>Pagado 1ª cuota (falta 2ª)</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box p={1}>
                <Grid container spacing={1}>
                  <Grid item sm={2} xs={12}>
                    <FormControl fullWidth={true}
                      variant="standard"
                    >
                      <InputLabel id="tipo_label">Estado Contribuyente</InputLabel>
                      <Select labelId="tipo_label"
                        id="estado_contribuyente"
                        name="estado_contribuyente"
                        value={this.state.filters.estado_contribuyente ? this.state.filters.estado_contribuyente : '-1'}
                        onChange={this.handleFilterChange}
                      >
                        <MenuItem key='-1' value='-1'>Todos</MenuItem>
                        <MenuItem key='0' value='0'>Sin validar</MenuItem>
                        <MenuItem key='1' value='1'>Validado</MenuItem>
                        <MenuItem key='2' value='2'>Rechazado</MenuItem>
                        <MenuItem key='3' value='3'>Incompleto</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item sm={2} xs={12}>

                    <FormControl fullWidth={true}
                      variant="standard"
                    >
                      <InputLabel id="tipo_label">Estado Identificación vehículo</InputLabel>
                      <Select labelId="tipo_label"
                        id="estado_identificacion"
                        name="estado_identificacion"
                        value={this.state.filters.estado_identificacion ? this.state.filters.estado_identificacion : '-1'}
                        onChange={this.handleFilterChange}
                      >
                        <MenuItem key='-1' value='-1'>Todos</MenuItem>
                        <MenuItem key='0' value='0'>Sin validar</MenuItem>
                        <MenuItem key='1' value='1'>Validado</MenuItem>
                        <MenuItem key='2' value='2'>Rechazado</MenuItem>
                        <MenuItem key='3' value='3'>Incompleto</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item sm={2} xs={12}>

                    <FormControl fullWidth={true}
                      variant="standard"
                    >
                      <InputLabel id="tipo_label">Estado Revisión técnica</InputLabel>
                      <Select labelId="tipo_label"
                        id="estado_prt"
                        name="estado_prt"
                        value={this.state.filters.estado_prt ? this.state.filters.estado_prt : '-1'}
                        onChange={this.handleFilterChange}
                      >
                        <MenuItem key='-1' value='-1'>Todos</MenuItem>
                        <MenuItem key='0' value='0'>Sin validar</MenuItem>
                        <MenuItem key='1' value='1'>Validado</MenuItem>
                        <MenuItem key='2' value='2'>Rechazado</MenuItem>
                        <MenuItem key='3' value='3'>Incompleto</MenuItem>
                      </Select>
                    </FormControl>

                  </Grid>

                  <Grid item sm={2} xs={12}>

                    <FormControl fullWidth={true}
                      variant="standard"
                    >
                      <InputLabel id="tipo_label">Estado Seguro obligatorio</InputLabel>
                      <Select labelId="tipo_label"
                        id="estado_soap"
                        name="estado_soap"
                        value={this.state.filters.estado_soap ? this.state.filters.estado_soap : '-1'}
                        onChange={this.handleFilterChange}
                      >
                        <MenuItem key='-1' value='-1'>Todos</MenuItem>
                        <MenuItem key='0' value='0'>Sin validar</MenuItem>
                        <MenuItem key='1' value='1'>Validado</MenuItem>
                        <MenuItem key='2' value='2'>Rechazado</MenuItem>
                        <MenuItem key='3' value='3'>Incompleto</MenuItem>
                      </Select>
                    </FormControl>

                  </Grid>

                  <Grid item sm={2} xs={12}>

                    <FormControl fullWidth={true}
                      variant="standard"
                    >
                      <InputLabel id="tipo_label">Estado SII</InputLabel>
                      <Select labelId="tipo_label"
                        id="estado_sii"
                        name="estado_sii"
                        value={this.state.filters.estado_sii ? this.state.filters.estado_sii : '-1'}
                        onChange={this.handleFilterChange}
                      >
                        <MenuItem key='-1' value='-1'>Todos</MenuItem>
                        <MenuItem key='0' value='0'>Sin validar</MenuItem>
                        <MenuItem key='1' value='1'>Validado</MenuItem>
                        <MenuItem key='2' value='2'>Rechazado</MenuItem>
                        <MenuItem key='3' value='3'>Incompleto</MenuItem>
                      </Select>
                    </FormControl>

                  </Grid>

                  <Grid item sm={2} xs={12}>

                    <FormControl fullWidth={true}
                      variant="standard"
                    >
                      <InputLabel id="tipo_label">Estado multas</InputLabel>
                      <Select labelId="tipo_label"
                        id="estado_multas"
                        name="estado_multas"
                        value={this.state.filters.estado_multas ? this.state.filters.estado_multas : '-1'}
                        onChange={this.handleFilterChange}
                      >
                        <MenuItem key='-1' value='-1'>Todos</MenuItem>
                        <MenuItem key='0' value='0'>Sin validar</MenuItem>
                        <MenuItem key='1' value='1'>Validado</MenuItem>
                        <MenuItem key='2' value='2'>Rechazado</MenuItem>
                        <MenuItem key='3' value='3'>Incompleto</MenuItem>
                      </Select>
                    </FormControl>

                  </Grid>
                </Grid>
              </Box>
            </Box>
          }
          <Box p={1}>

            <Grid container spacing={1}>
              <Grid item sm={8} xs={12}>
                <FormControl fullWidth={true}
                  variant="standard"
                >
                  <InputLabel id="order_by">Ordenar por</InputLabel>
                  <Select labelId="order_by"
                    id="order_by"
                    name="order_by"
                    value={this.state.pagination.order_by}
                    onChange={this.handlePaginationChange}
                  >
                    <MenuItem key='fecha_actualizacion' value='fecha_actualizacion'>Fecha última actualización</MenuItem>
                    <MenuItem key='email' value='email'>Email contribuyente</MenuItem>
                    <MenuItem key='patente' value='patente'>Patente vehículo</MenuItem>
                    <MenuItem key='username' value='username'>Agente</MenuItem>
                    <MenuItem key='estado_consolidado' value='estado_consolidado'>Estado permiso</MenuItem>
                    <MenuItem key='numero_completos' value='numero_completos'>Número de secciones listas</MenuItem>
                    <MenuItem key='numero_incompletos' value='numero_incompletos'>Número de secciones incompletas</MenuItem>
                    <MenuItem key='numero_rechazados' value='numero_rechazados'>Número de secciones rechazadas</MenuItem>
                    <MenuItem key='numero_notificaciones' value='numero_notificaciones'>Número de notificaciones</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={4} xs={12}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="order"
                    id="order"
                    value={this.state.pagination.order}
                    onClick={this.handlePaginationChange}
                  >
                    <FormControlLabel value="asc" control={<Radio />} label="Ascendente" />
                    <FormControlLabel value="desc" control={<Radio />} label="Decreciente" />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

          </Box>

          <Box p={1} m={1}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={3}>
                <Grid container spacing={1}>
                  <Grid item md={6} sm={12}>
                    <DesktopDatePicker label="Fecha inicial (inclusive)"
                      id='start_date'
                      name='start_date'
                      inputFormat="dd/MM/yyyy"
                      value={this.state.filters.start_date}
                      onChange={(date) => this.handleDateFilter('start_date', date)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                  <Grid item md={6} sm={12}>

                    <DesktopDatePicker label="Fecha termino (inclusive)"
                      id='end_date'
                      name='end_date'
                      inputFormat="dd/MM/yyyy"
                      value={this.state.filters.end_date}
                      onChange={(date) => this.handleDateFilter('end_date', date)}
                      renderInput={(params) => <TextField {...params} />}
                    />

                  </Grid>
                </Grid>
              </Stack>
            </LocalizationProvider>
          </Box>


          <Grid container>
            <Grid item xs={6}>
              <Button color='primary'
                onClick={this.handleFiltrar}
                startIcon={<SearchIcon />}
                variant='contained'
              >
                Filtrar
              </Button>
              <Button color='primary'
                onClick={this.handleDescargarExcel}
                disabled={this.state.html.descargando_excel}
                startIcon={this.state.html.descargando_excel ? <CircularProgress size={18} /> : <FileDownloadIcon />}
                variant='outlined'
                sx={{ ml: 1 }}
              >
                {this.state.html.descargando_excel ? 'Generando Excel...' : 'Descargar búsqueda en Excel'}
              </Button>
            </Grid>
            <Grid item xs={6} align='right'>

              <Button color='secondary'
                onClick={event => this.handleLoad(true)}
                startIcon={<RestartAltIcon />}
              >
                Limpiar Filtros
              </Button>
            </Grid>
          </Grid>

          <Box>


            {this.state.objects.length > 0 && !this.state.html.loading &&
              <Box p={1}>
                <Grid container>
                  <Grid item sm={6} align='right'>
                    <FormControl variant="standard"
                    >
                      <InputLabel id="tipo_label">Página</InputLabel>
                      <Select labelId="tipo_label"
                        id="page"
                        name="page"
                        value={this.state.pagination.page ? this.state.pagination.page : 0}
                        onChange={this.handleChangePageManual}
                      >
                        {Array.from(Array(this.state.pagination.pages_num).keys()).map((object) => {
                          return (
                            <MenuItem key={object} value={object}>{object + 1}</MenuItem>
                          )
                        })}

                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={6}>
                    <TablePagination
                      labelRowsPerPage='Resultados por página'
                      component="div"
                      count={this.state.pagination.rows_num}
                      page={this.state.pagination.page}
                      onPageChange={this.handleChangePage}
                      rowsPerPage={this.state.pagination.rows_per_page}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </Grid>
                </Grid>

                <TableContainer>
                  <Table size="small">
                    <EnhancedTableHead
                      order={this.state.pagination.order}
                      orderBy={this.state.pagination.order_by}
                      onRequestSort={this.handleSort}
                    />
                    <TableBody>
                      {this.state.objects.map((object) => {
                        return (
                          <Row key={object.permiso_uuid} object={object} />
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            }
            {this.state.html.loading &&
              <CircularProgress />
            }
            {this.state.objects.length === 0 && !this.state.html.loading &&
              <Box>
                <Box p={1}>
                  <Alert severity='warning'>
                    No se encontraron vehículos
                  </Alert>
                </Box>
              </Box>
            }
          </Box>
        </Box>
      </Paper>

    );
  }
}

export default BandejaPermisos;
